<main class="public-page">
  <menu-portale></menu-portale>

  <section-title title="Scopri di più"></section-title>

  <section class="portale-section">
    <div class="section-title">
      <h2>Richiedi le credenziali al tuo medico curante</h2>
    </div>

    <div class="steps-list">
      <div class="steps-list__item"><span class="steps-list__number">1</span><p>Il tuo medico ti fornirà utente e password.</p></div>
      <div class="steps-list__item"><span class="steps-list__number">2</span><p>È obbligatorio modificare la password al primo accesso.</p></div>
      <div class="steps-list__item"><span class="steps-list__number">3</span><p>Il medico ha facoltà di decidere se e quali dati condividere.</p></div>
      <div class="steps-list__item"><span class="steps-list__number">4</span><p>All'interno della tua area è presente un manuale online che descrive tutte le funzioni nel dettaglio.</p></div>
      <div class="steps-list__item"><span class="steps-list__number">5</span><p>Puoi usare il portale dal browser o l'app per ricevere le notifiche sul tuo smartphone.</p></div>
    </div>
  </section>

  <section class="portale-section portale-section--tint">
    <div class="section-title">
      <h2>Dopo l'accesso vedrai i dati clinici che il medico ha deciso di condividere.</h2>
    </div>
    <img class="media-frame" src="assets/portal/images/uploads/screenshotriassunto (1).jpg" alt="Riepilogo dei dati clinici" />
  </section>

  <section class="portale-section">
    <div class="section-title">
      <h2>Qui potrai comunicare con il tuo medico.</h2>
    </div>
    <img class="media-frame" src="assets/portal/images/uploads/com-por.png" alt="Area comunicazioni con il medico" />
  </section>

  <app-scarica-app-section></app-scarica-app-section>

  <app-portale-layout-footer></app-portale-layout-footer>
</main>
